import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import whats from '@/assets/images/whats.png';
import { waService } from '@/services/domain/WhatsAppService';

const faqData = [
  {
    id: 1,
    question: "Vocês atendem emergências?",
    answer: "Não, nossa clínica não atende emergências. Trabalhamos apenas com consultas agendadas para oferecer o melhor atendimento possível."
  },
  {
    id: 2,
    question: "Qual a idade mínima para vacinar meu gatinho?",
    answer: "A primeira vacinação pode ser feita a partir de 6-8 semanas de idade. Agende uma consulta para avaliarmos o protocolo ideal para seu felino."
  },
  {
    id: 3,
    question: "Vocês fazem entrega dos produtos?",
    answer: "Sim! Entre em contato via WhatsApp para verificar a disponibilidade de entrega na sua região e os valores."
  },
  {
    id: 4,
    question: "Como agendar uma consulta?",
    answer: "Você pode agendar pelo WhatsApp ou telefone. Trabalhamos com horários marcados para garantir um atendimento tranquilo para seu gato."
  },
  {
    id: 5,
    question: "Vocês atendem outros animais além de gatos?",
    answer: "Não, somos especializados exclusivamente em felinos. Isso nos permite oferecer um cuidado mais especializado e um ambiente adequado para gatos."
  }
];

const FaqPage = () => {
  const [openFaqId, setOpenFaqId] = useState<number | null>(null);
  const heroWhatsAppHref = useMemo(() => {
    try {
      return waService.buildUrl({ message: 'Olá! Tenho uma dúvida sobre os serviços da Casa dos Gatos.' });
    } catch (error) {
      console.error('Número do WhatsApp não configurado corretamente.', error);
      return undefined;
    }
  }, []);

  const helpWhatsAppHref = useMemo(() => {
    try {
      return waService.buildUrl({ message: 'Olá! Preciso de ajuda com uma dúvida específica.' });
    } catch (error) {
      console.error('Número do WhatsApp não configurado corretamente.', error);
      return undefined;
    }
  }, []);

  return (
    <section className="faq">
      <div className="container">
        <div className="faq-hero">
          <span className="faq-hero-tag">FAQ Felino</span>
          <h2>Perguntas Frequentes</h2>
          <p>
            Tire suas dúvidas sobre nossos serviços, cuidados clínicos e experiências n'A Casa dos Gatos.
            Estamos prontos para ajudar você e seu felino em cada etapa.
          </p>
          <div className="faq-hero-actions">
            <a
              href={heroWhatsAppHref}
              className="btn-cta primary"
              target="_blank"
              rel="noopener noreferrer"
              aria-disabled={!heroWhatsAppHref}
            >
              <img src={whats} alt="WhatsApp" className="btn-cta-icon btn-cta-icon-whats" />
              Conversar pelo WhatsApp
            </a>
            <Link to="/contato" className="btn-cta secondary faq-hero-link">
              Ver página de Contato
            </Link>
          </div>
        </div>

        <div className="faq-grid">
          <div className="faq-card">
            <div className="faq-card-header">
              <h3>Dúvidas mais comuns</h3>
              <p className="faq-card-subtitle">Clique para expandir e conferir detalhes sobre nossos serviços.</p>
            </div>
            <div className="faq-list">
              {faqData.map((faq) => (
                <div key={faq.id} className="faq-item">
                  <button
                    type="button"
                    className={`faq-question ${openFaqId === faq.id ? 'active' : ''}`}
                    onClick={() => setOpenFaqId(openFaqId === faq.id ? null : faq.id)}
                  >
                    <span>{faq.question}</span>
                    <span className="faq-icon">{openFaqId === faq.id ? '−' : '+'}</span>
                  </button>
                  {openFaqId === faq.id && (
                    <div className="faq-answer">
                      <p>{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="faq-help-card">
            <div className="faq-help-header">
              <h3>Precisa de algo específico?</h3>
              <p>Nosso time responde rapidamente pelos canais oficiais:</p>
            </div>
            <ul className="faq-help-list">
              <li>Orientações sobre vacinas, exames e consultas.</li>
              <li>Disponibilidade de produtos e entregas.</li>
              <li>Agendamentos personalizados para o seu felino.</li>
            </ul>
            <div className="faq-help-actions">
              <a
                href={helpWhatsAppHref}
                className="btn-cta primary"
                target="_blank"
                rel="noopener noreferrer"
                aria-disabled={!helpWhatsAppHref}
              >
                <img src={whats} alt="WhatsApp" className="btn-cta-icon btn-cta-icon-whats" />
                Conversar pelo WhatsApp
              </a>
              <Link to="/contato" className="btn-cta secondary">
                📍 Ver contatos completos
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqPage;